module.exports = __webpack_public_path__ + "img/selected3-min.3b7e1dee.png";